import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

//

export const newsLetterClubListApi = (data) =>
    API.get(`${URL.NEWS_LETTER_LIST_FOR_CLUB}/${data.ID}`, data.params)
export const newsLetterDocumentListApi = (data) =>
    API.get(`${URL.DOCUMENT_BY_CLUB_LIST}/${data.ID}`, data.params)